import * as KatalMetrics from '@amzn/katal-metrics';
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi';
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';
import { STAGE } from './constants/context';

const metricsConsoleErrorHandler = (err: Error) => console.error(err);

const sushiStageMap: Record<string, string> = {
  'Prod': 'prod',
  'Beta': 'beta',
  'default': 'test',
}

const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
  if (process.env.NODE_ENV === 'test') {
    const metricsDriver = new KatalMetricsDriverArrayCollector();
    //  Attach to global window object so tests can see it
    (window as any).metricsDriver = metricsDriver;
    return metricsDriver;
  } else if (sushiStageMap[STAGE] == 'beta') {
    return new KatalMetricsDriverSushi.Builder()
      .withDomainRealm('prod', 'USAmazon')
      .withErrorHandler(metricsConsoleErrorHandler)
      .withCustomSourceGroup('com.amazon.AtoZMyResultsApp.beta.katalmetrics')
      .build();
  } else if (sushiStageMap[STAGE] == 'prod') {
    return new KatalMetricsDriverSushi.Builder()
      .withDomainRealm('prod', 'USAmazon')
      .withErrorHandler(metricsConsoleErrorHandler)
      .withCustomSourceGroup('com.amazon.AtoZMyResultsApp.prod.katalmetrics')
      .build();
  } else {
    return new KatalMetricsDriverConsoleLogJson();
  }
};

const makePublisher = (metricsDriver: KatalMetrics.MetricsDriver): KatalMetrics.Publisher => {
  const initialMetricsContext = new KatalMetrics.Context.Builder()
    .withSite('MyResults')
    .withServiceName('AtoZMyResultsApp')
    .build();
  return new KatalMetrics.Publisher(
    metricsDriver,
    metricsConsoleErrorHandler,
    initialMetricsContext);
};

export const initialMetricsPublisher = makePublisher(makeMetricsDriver());
